import { UserManagementPage } from '@/components/admin/user-management-page'

export function AdminCustomerUsersPage() {
  return <UserManagementPage mode="customers" />
}
